import { gql } from "@apollo/client";

export const listCheckins = gql`
  query listCheckIns($filter: ModelCheckInFilterInput, $nextToken: String) {
    listCheckIns(filter: $filter, nextToken: $nextToken) {
      nextToken
      items {
        usercheckin {
          items {
            userid
            user {
              firstName
              lastName
              id
            }
          }
        }
        skills {
          name
          definitions {
            definition
            frequency
            sequenceNo
          }
        }
        allCheckinRaters {
          userid
          firstName
          lastName
          profileImage {
            url
            fileName
            key
          }
        }
        allCheckinRatees {
          userid
          firstName
          lastName
          profileImage {
            url
            fileName
            key
          }
        }
        checkInType
        combinedCheckInTypes
        checkinCoachId
        createdAt
        description
        endDate
        frequencyRepeatsOn
        id
        isCheckinLibrary
        isCommentResponse
        isDeleted
        isUploadResponse
        name
        updatedAt
        totalCheckin
        startDate
        scheduleFrequency
        notifyCoacheeBeforeDays
        notifyCoachee
        createdByUserId
        companyId
        assignedToTargets {
          id
          title
        }
        eventCheckin {
          details
        }
        textCheckin {
          description
        }
        linkCheckin {
          link
          title
          description
          image
        }
        surveyCheckin {
          surveycheckin {
            answer
            options
            question
            questionType
            userAnswer
          }
          isanonymous
          score
        }
        multimediaCheckin {
          fileType
          s3Link {
            fileName
            url
            uploadUrl
            key
            region
            isNew
            bucket
          }
          isVideoUrl
        }
        eventCheckin {
          details
          eventDate
          eventTime
          eventType
          location
          url
          documents {
            bucket
            fileName
            isNew
            key
            region
            uploadUrl
            url
          }
        }
      }
    }
  }
`;

export const getCheckinDetails = gql`
  query getCheckinDetails($id: ID!) {
    getCheckIn(id: $id) {
      id
      target {
        id
        title
        description
        type
      }
    }
  }
`;

export const getObjectiveDetails = gql`
  query getObjectiveTarget($id: ID!) {
    getObjectiveTarget(id: $id) {
      id
      target {
        id
        title
        description
        type
      }
    }
  }
`;

export const getCompletedSurveyResponse = gql`
  query getCompletedSurveyResponse(
    $checkinId: ID!
    $sequenceNo: Int
    $nextToken: String
  ) {
    getCheckIn(id: $checkinId) {
      completeSurveyCheckin(sequenceNo: $sequenceNo, nextToken: $nextToken) {
        completedSurveyCheckin {
          questionType
          question
          dueDate
          completedUsers
          status
          totalUsers
          average
          answer
          userResponse {
            user {
              id
              firstName
              lastName
              profileImage {
                url
                fileName
              }
            }
            attachmentLink {
              link
              description
              title
              image
            }
            requestFeedbackAttachments {
              fileType
              s3Link {
                bucket
                fileName
                key
                region
                uploadUrl
                url
                isNew
                __typename
              }
              isVideoUrl
            }
            responseDate
            response
            isCorrect
          }
          userResponsePieChart {
            responseStatistics {
              text
              count
              color
              percentage
              correct
              users {
                firstName
                lastName
                profileImage {
                  fileName
                }
              }
            }
          }
        }
        nextToken
      }
    }
  }
`;

export const getPeopleSurveyResponse = gql`
  query getPeopleSurveyResponse($checkinId: ID!, $sequenceNo: Int) {
    getCheckinDetails(checkinId: $checkinId, sequenceNo: $sequenceNo) {
      checkInType
      userCheckinData {
        checkInEndDate
        checkInStatus
        usercomment
        userid
        isNewRowHighlight
        average
        user {
          id
          status
          profileImage {
            url
            fileName
            key
          }
          firstName
          lastName
        }
        attachmentLink {
          link
          description
          title
          image
        }
        requestFeedbackAttachments {
          fileType
          s3Link {
            bucket
            fileName
            key
            region
            uploadUrl
            url
            isNew
          }
          isVideoUrl
        }
        surveyCheckin {
          surveycheckin {
            questionType
            question
            answer
            options
            userAnswer
            isCorrect
          }
        }
      }
    }
  }
`;

export const getLearningResponse = gql`
  query getLearningResponse($checkinId: ID!, $sequenceNo: Int) {
    getCheckinDetails(checkinId: $checkinId, sequenceNo: $sequenceNo) {
      userCheckinData {
        id
        updatedAt
        checkin {
          id
          checkInTargetId
        }
        isNewRowHighlight
        isNewResponseHighlight
        checkInEndDate
        checkInStatus
        userid
        user {
          id
          status
          profileImage {
            url
            fileName
            key
          }
          firstName
          lastName
        }
        usercomment
        usercommentDate
        coachComment
        coachCommentDate
        commentedBy {
          profileImage {
            url
            fileName
            key
          }
          firstName
          lastName
        }
        responseDocument {
          fileName
          key
          bucket
          url
        }
        attachmentLink {
          link
          title
          description
          image
        }
        responseDocumentDate
      }
    }
  }
`;
export const submitLearningResponse = gql`
  mutation submitLearningResponse(
    $userId: ID!
    $checkinId: ID
    $comment: String
    $commentedById: ID
  ) {
    checkinMutation(
      input: {
        userCheckin: {
          id: $userId
          coachComment: $comment
          commentedById: $commentedById
        }
        id: $checkinId
      }
    ) {
      id
    }
  }
`;

export const getLearningSummary = gql`
  query getLearning($id: ID!, $userId: ID!) {
    getCheckIn(id: $id) {
      usercheckin(userid: { eq: $userId }) {
        items {
          coachComment
          coachCommentDate
          id
          checkInStatus
          checkinSequenceNo
          usercomment
          updatedAt
          usercommentDate
          responseDocument {
            base64Data
            bucket
            fileName
            isNew
            key
            url
          }
          attachmentLink {
            link
            title
            description
            image
          }
          responseDocumentDate
        }
      }
      id
      name
      description
      checkInType
      scheduleFrequency
      startDate
      endDate
      createdAt
      isCheckinLibrary
      createdBy {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
      }
      checkInStatus
      daysToComplete
      isCommentResponse
      isUploadResponse
      isTestSurvey
      checkInTargetId
      checkinCoachId
      templateEndDateTime
      templateLaunchDay
      templateLaunchDateTime
      launchTime
      dueTime
      isImmediate
      userCheckinDetails {
        endDate
        checkinSequenceNo
        id
        isCurrentFrequency
        startDate
        status
      }
      checkinFrequencyDates {
        startDate
        endDate
        sequenceNo
      }
      checkinCoach {
        profileImage {
          url
          fileName
        }
        id
        firstName
        lastName
        fullName
      }
      skills {
        definitions {
          definition
          frequency
        }
        name
      }
      linkCheckin {
        link
        description
        title
        image
      }
      multimediaCheckin {
        fileType
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
        }
        isVideoUrl
      }
      surveyLinks {
        link
        description
        title
        image
      }
      surveyMultimediaCheckin {
        fileType
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
          isNew
          __typename
        }
        isVideoUrl
        __typename
      }
      surveyCheckin {
        isanonymous
        score
        surveycheckin {
          answer
          options
          question
          questionType
          userAnswer
        }
      }
      usersForCheckin {
        items {
          user {
            firstName
            lastName
            status
            id
            profileImage {
              url
              fileName
            }
            department
            role
            designation
            supervisor {
              id
              fullName
              firstName
              lastName
              profileImage {
                fileName
              }
            }
          }
        }
      }
      allCheckinViewers {
        isAddedFromBE
        lastName
        firstName
        status
        userid
        profileImage {
          key
          fileName
          url
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
      allCheckinRatees {
        firstName
        lastName
        userid
        profileImage {
          url
          fileName
          key
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
      allCheckinRaters {
        lastName
        firstName
        userid
        profileImage {
          key
          fileName
          url
        }
        department
        role
        designation
        supervisor {
          id
          fullName
          firstName
          lastName
          profileImage {
            fileName
          }
        }
      }
    }
  }
`;
export const getSkillRating = gql`
  query getSkillRating($checkinId: ID, $usercheckinId: ID) {
    getRateesToRate(checkinId: $checkinId, usercheckinId: $usercheckinId) {
      rateesToRate {
        ratee {
          id
          userid
          fullName
          firstName
          lastName
          status
          profileImage {
            fileName
          }
        }
        status
        skillRatingResponse {
          scoreToDisplay
          id
          checkinId
          resumeSkillRatingAt {
            questionNo
            skillName
          }
          skills {
            score
            name
            status
            comment
            visibleToRatee
            definitions {
              sequenceNo
              feedback
              frequency
              definition
            }
          }
        }
      }
    }
  }
`;
export const responseSummaryReport = gql`
  query responseSummaryReport($checkinId: ID, $sequenceNo: Int) {
    responseSummaryReport(checkinId: $checkinId, sequenceNo: $sequenceNo) {
      frequency {
        question
        questionType
        userDetail {
          completionDate
          userAnswer
          user {
            firstName
            lastName
            profileImage {
              fileName
              uploadUrl
              key
              url
            }
          }
        }
        average
        responseDate
        totalUsers
        answer
        options {
          color
          count
          percentage
          sequenceNo
          text
          correct
          users {
            firstName
            lastName
            profileImage {
              fileName
              uploadUrl
              key
              url
            }
          }
        }
      }
      totalUsersList {
        firstName
        lastName
        status
        profileImage {
          fileName
        }
        checkInStatus
        isNew
        isNewHighlight
        userId
      }
      totalUsers
      average
      completedUsers
    }
  }
`;

export const responseSummary = gql`
  query responseSummary(
    $checkinId: ID
    $checkInStatus: CheckinStatus!
    $questionIndex: Int
    $questionType: QuestionType
  ) {
    responseSummaryReport(
      checkinId: $checkinId
      checkInStatus: $checkInStatus
      questionIndex: $questionIndex
      questionType: $questionType
    ) {
      frequency {
        question
        questionType
        average
        options {
          text
          count
          percentage
          color
        }
        totalUsers
        responseDate
      }
    }
  }
`;

export const listCheckinSchedule = gql`
  query listCheckinSchedule(
    $checkinId: ID
    $targetId: ID
    $createdByUserId: ID
    $userId: ID
    $filter: TargetFilterType
    $type: ListCheckinScheduleEnum
  ) {
    listCheckinSchedule(
      checkinId: $checkinId
      targetId: $targetId
      createdByUserId: $createdByUserId
      userId: $userId
      type: $type
      filter: $filter
    ) {
      id
      name
      checkInTargetId
      description
      startDate
      endDate
      checkInType
      combinedCheckInTypes
      enableViewResponse
      publishPeriod
      checkinDetails {
        totalAssignedCoachees
        status
        totalCompletedCoachees
        startDate
        endDate
        isCurrentFrequency
        checkinSequenceNo
      }
      eventCheckin {
        details
        documents {
          bucket
          fileName
          key
          region
          uploadUrl
          url
        }
        eventDate
        eventTime
        eventType
        location
        url
      }
      linkCheckin {
        link
        title
        description
        image
      }
      multimediaCheckin {
        fileType
        isVideoUrl
        s3Link {
          bucket
          fileName
          key
          region
          uploadUrl
          url
        }
        isVideoUrl
      }
      surveyCheckin {
        isanonymous
        score
        surveycheckin {
          answer
          options
          question
          questionType
          userAnswer
        }
      }
      textCheckin {
        description
      }
      createdByUserId
      createdBy {
        profileImage {
          fileName
        }
        firstName
        lastName
        fullName
        department
      }
      usercheckin {
        items {
          id
          checkinid
          userid
          checkInStatus
          updatedAt
          checkInStartDate
          checkInEndDate
          checkinSequenceNo
          checkinCommentLikeUsersID
          checkinCommentLikeUsers {
            id
            firstName
            lastName
            fullName
          }
          responseDocument {
            url
            fileName
          }
          surveyCheckin {
            isanonymous
            score
            surveycheckin {
              answer
              options
              question
              questionType
              userAnswer
            }
          }
          usercomment
          checkInStatus
        }
      }
      userCheckinDetails {
        id
        status
        startDate
        endDate
        checkinSequenceNo
        ratees {
          status
          ratee {
            userid
            firstName
            lastName
            profileImage {
              url
              fileName
            }
          }
        }
      }
      target {
        id
      }
    }
  }
`;
// notifyCoacheeBeforeDays
export const checkinTemplateList = gql`
  query checkinTemplateList {
    getCheckinTemplateList {
      name
      createdAt
      combinedCheckInTypes
      usercheckin {
        items {
          userid
          user {
            profileImage {
              url
              fileName
              key
            }
            firstName
            lastName
            id
          }
        }
      }
      allCheckinRaters {
        userid
        firstName
        lastName
        profileImage {
          url
          fileName
          key
        }
      }
      allCheckinRatees {
        userid
        firstName
        lastName
        profileImage {
          url
          fileName
          key
        }
      }
      skills {
        name
        definitions {
          definition
          frequency
          sequenceNo
        }
      }
      checkInType
      combinedCheckInTypes
      checkinCoachId
      publishPeriod
      checkinCoach {
        profileImage {
          url
          fileName
        }
        firstName
        lastName
      }
      description
      endDate
      frequencyRepeatsOn
      id
      isCheckinLibrary
      isCommentResponse
      isDeleted
      isUploadResponse
      startDate
      scheduleFrequency
      notifyCoachee
      companyId
      name
      createdAt
      createdByUserId
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
      assignedToTargets {
        id
        title
      }
      eventCheckin {
        details
      }
      textCheckin {
        description
      }
      linkCheckin {
        link
        title
        description
        image
      }
      surveyCheckin {
        surveycheckin {
          answer
          options
          question
          questionType
          userAnswer
        }
        isanonymous
        score
      }
      multimediaCheckin {
        fileType
        s3Link {
          fileName
          url
          uploadUrl
          key
          region
          isNew
          bucket
        }
        isVideoUrl
      }
      eventCheckin {
        details
        eventDate
        eventTime
        eventType
        location
        url
        documents {
          bucket
          fileName
          isNew
          key
          region
          uploadUrl
          url
        }
      }
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
    }
  }
`;

export const checkinTemplates = gql`
  query checkinTemplates($filter: String, $listType: CheckinTemplateListType) {
    getCheckinTemplateList(filter: $filter, listType: $listType) {
      id
      name
      updatedAt
      createdAt
      combinedCheckInTypes
      checkInType
      combinedCheckInTypes
      checkinCoachId
      companyId
      daysToComplete
      usercheckin {
        items {
          id
        }
      }
      isImmediate
      templateLaunchDay
      name
      createdAt
      createdByUserId
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
        status
      }
      assignedToTargets {
        id
        title
        logo {
          fileName
        }
      }
    }
  }
`;

export const searchTemplateOverview = gql`
  query checkinTemplates($filter: String, $listType: CheckinTemplateListType) {
    getCheckinTemplateList(filter: $filter, listType: $listType) {
      id
      name
      combinedCheckInTypes
      checkInType
      createdByUserId
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
    }
  }
`;

export const previewCheckinTemplates = gql`
  query previewCheckin($id: ID!) {
    getCheckIn(id: $id) {
      id
      name
      createdAt
      combinedCheckInTypes
      checkInType
      combinedCheckInTypes
      checkinCoachId
      publishPeriod
      daysToComplete
      checkinCoach {
        profileImage {
          url
          fileName
        }
        firstName
        lastName
      }
      description
      endDate
      startDate
      companyId
      name
      createdAt
      createdByUserId
      createdBy {
        firstName
        lastName
        profileImage {
          url
          fileName
        }
      }
      assignedToTargets {
        id
        title
      }
      usercheckin {
        items {
          userid
          user {
            profileImage {
              url
              fileName
              key
            }
            firstName
            lastName
            id
          }
        }
      }
      allCheckinRaters {
        userid
        firstName
        lastName
        profileImage {
          url
          fileName
          key
        }
      }
      allCheckinRatees {
        userid
        firstName
        lastName
        profileImage {
          url
          fileName
          key
        }
      }
      skills {
        name
        definitions {
          definition
          frequency
          sequenceNo
        }
      }
      frequencyRepeatsOn
      isCheckinLibrary
      isCommentResponse
      isDeleted
      isUploadResponse
      scheduleFrequency
      notifyCoachee
      eventCheckin {
        details
      }
      textCheckin {
        description
      }
      linkCheckin {
        link
        image
        title
        description
      }
      surveyCheckin {
        surveycheckin {
          answer
          options
          question
          questionType
          userAnswer
        }
        isanonymous
        score
      }
      multimediaCheckin {
        fileType
        s3Link {
          fileName
          url
          uploadUrl
          key
          region
          isNew
          bucket
        }
        isVideoUrl
      }
      surveyLinks {
        link
        description
        title
        image
      }
      surveyMultimediaCheckin {
        fileType
        s3Link {
          fileName
          url
          uploadUrl
          key
          region
          isNew
          bucket
        }
        isVideoUrl
      }
      eventCheckin {
        details
        eventDate
        eventTime
        eventType
        location
        url
        documents {
          bucket
          fileName
          isNew
          key
          region
          uploadUrl
          url
        }
      }
    }
  }
`;
